import { IStore } from '..';

export const IS_SUPER_ADMIN = (store: IStore) => store.user.username === 'admin';
